import React, { useState } from "react";
import {
  Box,
  Divider,
  Grid,
  InputLabel,
  Paper,
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
  Snackbar,
  Alert,
  useMediaQuery,
} from "@mui/material";

import { config } from "../../../config/config";
import { apiList, invokeApi } from "../../../services/apiServices";
import { useCookies } from "react-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import Sidenav from "../../common/Sidenav";
import Header from "../../common/Header";
import IconSidenav from "../../common/IconSidenav";
import NavigatedComponent from "../NavigatedComponent";

function AddUser() {
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies] = useCookies();
  const [role, setRole] = useState("--Select--");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSideNav, setShowSideNav] = useState(false);
  const isMobileScreen = useMediaQuery(
    "(min-width:360px) and (max-width:500px)"
  );

  const toggleSideNav = () => {
    setShowSideNav(!showSideNav);
  };
  const handleRoleChange = (event) => {
    setRole(event.target.value);
    setErrors("");
  };
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        showSnackbar("User Added successfully", "success");
        await handleAddUser();
      } catch (error) {
        console.error("Error while adding user:", error);
        showSnackbar("Something went wrong. Please try again later!!");
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let formIsValid = true;

    if (!name.trim()) {
      newErrors.name = "Name is required";
      formIsValid = false;
    }

    if (!email.trim()) {
      newErrors.email = "Email is required";
      formIsValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email is invalid";
      formIsValid = false;
    }

    if (!phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone Number is required";
      formIsValid = false;
    } else if (!/^\d{10}$/.test(phoneNumber)) {
      newErrors.phoneNumber = "Phone Number is invalid";
      formIsValid = false;
    }

    if (!role.trim() || role === "--Select--") {
      newErrors.role = "Role is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleAddUser = async () => {
    const params = {
      name: name,
      email: email,
      phoneNumber: phoneNumber,
      roles: [role],
    };

    try {
      const response = await invokeApi(
        config.getMyCollege + apiList.userAdd,
        params,
        cookies,
        console.log(params)
      );

      if (response?.status >= 200 && response?.status < 300) {
        if (response.data.responseCode === "200") {
          showSnackbar("User Added successfully");

          navigate("/employee-manager/users");
        } else if (response.data.responseCode === "400") {
          showSnackbar(response.data.message, "error");
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
      showSnackbar("Something went wrong. Please try again later!!", "error");
    }
  };
  return (
    <div>
      <Grid sx={{ display: "flex" }}>
        {isMobileScreen ? (
          <IconSidenav />
        ) : showSideNav ? (
          <IconSidenav />
        ) : (
          <Sidenav />
        )}
        <Grid component="main" sx={{ width: "100%", px: 1 }}>
          <Header toggleSideNav={toggleSideNav} />
          <Grid sx={{ py: 1 }}>
            <NavigatedComponent pathname={location.pathname} />
            <Grid sx={{ width: "100%", px: isMobileScreen ? 1 : 5 }}>
              <Grid sx={{ mt: isMobileScreen ? 2 : 5 }}>
                <form onSubmit={handleSubmit}>
                  <Paper
                    sx={{
                      p: 3,
                    }}
                  >
                    <Typography
                      sx={{
                        mb: 2,
                        mx: isMobileScreen ? 2 : 8,
                        textAlign: "left",
                        fontSize: isMobileScreen ? 14 : 18,
                        fontWeight: 600,
                        // textDecorationLine: "underline",
                        textTransform: "uppercase",
                      }}
                    >
                      Add New employee Details:
                    </Typography>
                    <Divider sx={{ backgroundColor: "black" }}></Divider>

                    <Grid
                      container
                      spacing={isMobileScreen ? 0 : 2}
                      md={12}
                      xs={12}
                      sx={{ marginTop: "20px" }}
                    >
                      {/* Full Name */}
                      <Grid item md={6} xs={12}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Name*:
                        </InputLabel>
                        <TextField
                          placeholder="Enter Full Name"
                          fullWidth
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                            setErrors("");
                          }}
                          error={!!errors.name}
                          helperText={errors.name}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      {/* Email */}
                      <Grid item md={6} xs={12}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Email*:
                        </InputLabel>
                        <TextField
                          placeholder="admin@getmycollege.com"
                          fullWidth
                          type="email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setErrors("");
                          }}
                          error={!!errors.email}
                          helperText={errors.email}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      {/* Phone */}
                      <Grid item md={6} xs={12}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Phone*:
                        </InputLabel>
                        <TextField
                          placeholder="Enter Phone Number"
                          fullWidth
                          value={phoneNumber}
                          onChange={(e) => {
                            setPhoneNumber(e.target.value);
                            setErrors("");
                          }}
                          error={!!errors.phoneNumber}
                          helperText={errors.phoneNumber}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>
                      {/* roles */}
                      <Grid item md={6} xs={12}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Role*:
                        </InputLabel>
                        <Select
                          fullWidth
                          value={role}
                          onChange={handleRoleChange}
                          error={!!errors.role}
                          style={{
                            height: isMobileScreen ? "35px" : "40px",
                            fontSize: isMobileScreen ? 12 : 14,
                          }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: "200px",
                              },
                            },
                          }}
                        >
                          <MenuItem value="--Select--" disabled>
                            --Select--
                          </MenuItem>
                          <MenuItem
                            value={"Team Leader"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Team Leader
                          </MenuItem>
                          <MenuItem
                            value={"Telecaller"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Telecaller
                          </MenuItem>
                          <MenuItem
                            value={"Blog Author"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Blog Author
                          </MenuItem>
                          <MenuItem
                            value={"Partner"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Partner
                          </MenuItem>
                          <MenuItem
                            value={"Principal"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Principal
                          </MenuItem>
                          <MenuItem
                            value={"Interns"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Interns
                          </MenuItem>
                          <MenuItem
                            value={"DataAssure"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            DataAssure
                          </MenuItem>
                        </Select>
                        {errors.role && (
                          <Typography variant="caption" color="error">
                            {errors.role}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>

                    {/* Submit Button */}
                    <Box sx={{ marginTop: "15px", textAlign: "right" }}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{
                          my: 2,
                          px: 2,
                          fontSize: 12,
                          background: "#1d1a57",
                          color: "#FFF",
                          fontWeight: 600,
                          "&:hover": { background: "#1d1a57", color: "#FFF" },
                        }}
                      >
                        Add New User
                      </Button>
                    </Box>
                  </Paper>
                </form>
              </Grid>
              {/* Snackbar */}
              <Snackbar
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  onClose={handleCloseSnackbar}
                  severity={snackbarSeverity}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default AddUser;
